module.exports = __webpack_public_path__ + "media/images/icons/search-59333500f221ceac03d2f6ba20ea36e6.svg";